import { render, staticRenderFns } from "./SearchModal.vue?vue&type=template&id=2982db8a&scoped=true"
import script from "./SearchModal.vue?vue&type=script&lang=ts"
export * from "./SearchModal.vue?vue&type=script&lang=ts"
import style0 from "./SearchModal.vue?vue&type=style&index=0&id=2982db8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2982db8a",
  null
  
)

export default component.exports